import { Reducer } from 'redux';

import { DeliveryMethodsTypes, IDeliveryMethodsState } from './types';

const DEFAULT_STATE: IDeliveryMethodsState = {
  data: [],
  loading: false,
  error: false,
};

const reducer: Reducer<IDeliveryMethodsState> = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case DeliveryMethodsTypes.LOAD_REQUEST:
      return { ...state, loading: true };
    case DeliveryMethodsTypes.LOAD_SUCCESS:
      return { ...state, loading: false, error: false, data: action.payload };
    case DeliveryMethodsTypes.LOAD_FAILURE:
      return { ...state, loading: false, error: true, data: [] };
    default:
      return state;
  }
};

export default reducer;
